import { cn } from "@/lib/utils";
import scooterImg from "@/assets/brand-scooter.webp";

interface BrandLogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  showTag?: boolean;
}

const SIZE = {
  sm: { icon: "h-10 w-10", line: "text-[0.95rem]", gap: "gap-2" },
  md: { icon: "h-14 w-14", line: "text-[1.15rem]", gap: "gap-2.5" },
  lg: { icon: "h-9 w-9 xs:h-10 xs:w-10 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16", line: "text-[0.7rem] xs:text-[0.8rem] sm:text-[1rem] md:text-[1.15rem] lg:text-[1.35rem]", gap: "gap-1.5 md:gap-2.5" },
};

/**
 * BrandLogo — real e-scooter photo + 2-line domain wordmark.
 */
export const BrandLogo = ({ size = "md", className, showTag = false }: BrandLogoProps) => {
  const s = SIZE[size];
  return (
    <div className={cn("flex items-center min-w-0", s.gap, className)}>
      <div className="relative shrink-0">
        <img
          src={scooterImg}
          alt="Logotipo Patinete Eléctrico"
          width={256}
          height={256}
          decoding="async"
          className={cn(s.icon, "object-contain drop-shadow-[0_6px_18px_hsl(var(--primary)/0.35)]")}
        />
      </div>
      <div className="flex flex-col justify-center py-0.5 leading-[1] tracking-tight min-w-0 overflow-hidden">
        <div className="flex flex-col min-w-0">
          <span className={cn("wordmark whitespace-nowrap truncate", s.line)} aria-hidden>
            PATINETE<span className="text-primary/90">ELECTRICO</span>
          </span>
          <span className={cn("wordmark whitespace-nowrap truncate", s.line)} aria-hidden>
            SEGUNDAMANO<span className="wordmark__dot" />COM
          </span>
        </div>
        {showTag && (
          <span className="wordmark__tag hidden xs:block">Marketplace Nº1</span>
        )}
        <span className="sr-only">patineteelectricosegundamano.com</span>
      </div>
    </div>
  );
};

export default BrandLogo;